export interface ButtonLabelsInterface {
  next: string;
  pdf: string;
}

export interface HeadingLabelsInterface {
  create: string;
  edit: string;
}

export interface LabelInterface {
  entityNumber: string;
  phases: HeadingLabelsInterface;
  buttons: ButtonLabelsInterface;
}

export interface LabelsInterface {
  invoice: LabelInterface;
}

export const LabelKeys: LabelsInterface = {
  invoice: {
    entityNumber: 'InvoiceNumber',
    phases: {
      create: 'invoice.Create',
      edit: 'invoice.Edit'
    },
    buttons: {
      next: 'Preview',
      pdf: 'invoice.downloadPdf'
    }
  }};
